{
  "familyId": "REK-CIJF-DEEL",
  "questions": [
    {
      "id": "REK-CIJF-DEEL-001",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 96 ÷ 4",
      "options": [],
      "correctAnswer": "24",
      "data": {
        "acceptedAnswers": ["24"],
        "operand1": 96,
        "operand2": 4,
        "longDivision": {
          "dividend": 96,
          "divisor": 4
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staartdeling: per cijfer",
            "content": "96 ÷ 4: begin links. 9 ÷ 4 = 2 (rest 1). Haal de 6 naar beneden → 16. 16 ÷ 4 = 4. Antwoord: 24. Tip: werk van links naar rechts, neem steeds de rest mee.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "96 ÷ 4 = 24. Staartdeling: 9 ÷ 4 = 2 (rest 1). Haal de 6 naar beneden → 16. 16 ÷ 4 = 4. Antwoord: 24. Bij staartdeling werk je van links naar rechts en neem je de rest steeds mee naar het volgende cijfer.",
        "solutionSteps": [
          "9 ÷ 4 = 2, rest 1",
          "Haal 6 naar beneden → 16",
          "16 ÷ 4 = 4",
          "Antwoord: 24"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Negeert de rest bij het naar beneden halen" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-002",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 738 ÷ 6",
      "options": [],
      "correctAnswer": "123",
      "data": {
        "acceptedAnswers": ["123"],
        "operand1": 738,
        "operand2": 6,
        "longDivision": {
          "dividend": 738,
          "divisor": 6
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staartdeling met driecijferig getal",
            "content": "738 ÷ 6: 7 ÷ 6 = 1 (rest 1). Haal 3 naar beneden → 13. 13 ÷ 6 = 2 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Antwoord: 123.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_3cijferig",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "738 ÷ 6 = 123. Staartdeling: 7 ÷ 6 = 1 (rest 1). Haal 3 naar beneden → 13. 13 ÷ 6 = 2 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Antwoord: 123.",
        "solutionSteps": [
          "7 ÷ 6 = 1, rest 1",
          "Haal 3 naar beneden → 13 ÷ 6 = 2, rest 1",
          "Haal 8 naar beneden → 18 ÷ 6 = 3",
          "Antwoord: 123"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Negeert de rest bij het naar beneden halen" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-003",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 475 ÷ 5",
      "options": [],
      "correctAnswer": "95",
      "data": {
        "acceptedAnswers": ["95"],
        "operand1": 475,
        "operand2": 5,
        "longDivision": {
          "dividend": 475,
          "divisor": 5
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen door 5: let op het eerste cijfer",
            "content": "475 ÷ 5: 4 ÷ 5 = 0 (4 is kleiner dan 5!). Neem 47: 47 ÷ 5 = 9 (rest 2). Haal 5 naar beneden → 25. 25 ÷ 5 = 5. Antwoord: 95. Let op: als het eerste cijfer kleiner is dan de deler, neem je twee cijfers samen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_eerste_kleiner",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "475 ÷ 5 = 95. Let op: 4 is kleiner dan 5, dus neem twee cijfers samen. 47 ÷ 5 = 9 (rest 2). Haal 5 naar beneden → 25. 25 ÷ 5 = 5. Antwoord: 95. Dit is een veelgemaakte fout: als het eerste cijfer kleiner is dan de deler, krijg je een antwoord met minder cijfers.",
        "solutionSteps": [
          "4 < 5, dus neem 47",
          "47 ÷ 5 = 9, rest 2",
          "Haal 5 naar beneden → 25 ÷ 5 = 5",
          "Antwoord: 95"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Negeert de rest bij het naar beneden halen" },
          { "id": "rek.partial-calculation", "label": "Vergeet dat eerste cijfer < deler twee cijfers samen vereist" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-004",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Een bloemist verdeelt 258 tulpen gelijk over 6 vazen. Hoeveel tulpen komen er in elke vaas?",
      "options": [],
      "correctAnswer": "43",
      "data": {
        "acceptedAnswers": ["43"],
        "operand1": 258,
        "operand2": 6,
        "longDivision": {
          "dividend": 258,
          "divisor": 6
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen = gelijk verdelen",
            "content": "258 ÷ 6: 25 ÷ 6 = 4 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Antwoord: 43 tulpen per vaas. Controleer: 43 × 6 = 258. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_context",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "258 ÷ 6 = 43. Staartdeling: 2 < 6, dus neem 25. 25 ÷ 6 = 4 (rest 1). Haal 8 naar beneden → 18. 18 ÷ 6 = 3. Elke vaas krijgt 43 tulpen. Controleer: 43 × 6 = 258. ✓",
        "solutionSteps": [
          "Herken: 258 tulpen ÷ 6 vazen",
          "25 ÷ 6 = 4, rest 1",
          "Haal 8 naar beneden → 18 ÷ 6 = 3",
          "Antwoord: 43 tulpen per vaas"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.divisor-dividend-swapped", "label": "Verwart deeltal en deler bij contextopgave" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-005",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 847 ÷ 7",
      "options": [],
      "correctAnswer": "121",
      "data": {
        "acceptedAnswers": ["121"],
        "operand1": 847,
        "operand2": 7,
        "longDivision": {
          "dividend": 847,
          "divisor": 7
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staartdeling: stap voor stap",
            "content": "847 ÷ 7: 8 ÷ 7 = 1 (rest 1). Haal 4 naar beneden → 14. 14 ÷ 7 = 2. Haal 7 naar beneden → 7. 7 ÷ 7 = 1. Antwoord: 121. Controleer: 121 × 7 = 847. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_3cijferig_complex",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "847 ÷ 7 = 121. Staartdeling: 8 ÷ 7 = 1 (rest 1). Haal 4 naar beneden → 14 ÷ 7 = 2. Haal 7 naar beneden → 7 ÷ 7 = 1. Antwoord: 121. Controleer altijd je antwoord: 121 × 7 = 847. ✓",
        "solutionSteps": [
          "8 ÷ 7 = 1, rest 1",
          "Haal 4 naar beneden → 14 ÷ 7 = 2",
          "Haal 7 naar beneden → 7 ÷ 7 = 1",
          "Antwoord: 121"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Negeert de rest bij het naar beneden halen" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-006",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 816 ÷ 4",
      "options": [],
      "correctAnswer": "204",
      "data": {
        "acceptedAnswers": ["204"],
        "operand1": 816,
        "operand2": 4,
        "longDivision": {
          "dividend": 816,
          "divisor": 4
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nul in het antwoord",
            "content": "816 ÷ 4: 8 ÷ 4 = 2. Haal 1 naar beneden. 1 ÷ 4 = 0 (kan niet!). Schrijf een 0 in het antwoord en haal de 6 erbij → 16. 16 ÷ 4 = 4. Antwoord: 204.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_nul_in_quotient",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "816 ÷ 4 = 204. Staartdeling: 8 ÷ 4 = 2. Haal 1 naar beneden. 1 ÷ 4 = 0. Schrijf de 0 op! Haal dan de 6 erbij → 16. 16 ÷ 4 = 4. Antwoord: 204. Vergeet de nul niet!",
        "solutionSteps": [
          "8 ÷ 4 = 2",
          "Haal 1 naar beneden: 1 ÷ 4 = 0",
          "Haal 6 erbij → 16 ÷ 4 = 4",
          "Antwoord: 204"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.zero-omission", "label": "Vergeet de nul in het quotiënt op te schrijven" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-007",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 1.236 ÷ 4",
      "options": [],
      "correctAnswer": "309",
      "data": {
        "acceptedAnswers": ["309"],
        "operand1": 1236,
        "operand2": 4,
        "longDivision": {
          "dividend": 1236,
          "divisor": 4
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nul in een groter quotiënt",
            "content": "1.236 ÷ 4: 1 ÷ 4 kan niet, neem 12. 12 ÷ 4 = 3. Haal 3 naar beneden: 3 ÷ 4 = 0 (kan niet!) — schrijf een 0 op. Haal 6 erbij → 36. 36 ÷ 4 = 9. Antwoord: 309. Bij viercijferige delingen blijft de nul-regel hetzelfde: niet vergeten op te schrijven!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_4cijferig_nul_quotient",
      "variantIndex": 7,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.81,
      "feedback": {
        "explanationText": "1.236 ÷ 4 = 309. Staartdeling: 1 < 4, dus neem 12. 12 ÷ 4 = 3. Haal 3 naar beneden → 3 ÷ 4 = 0. Schrijf de 0 op! Haal 6 erbij → 36. 36 ÷ 4 = 9. Antwoord: 309. Net als bij 816 ÷ 4: de nul in het quotiënt mag je nooit overslaan, ook niet in grotere getallen.",
        "solutionSteps": [
          "1 < 4, neem 12",
          "12 ÷ 4 = 3",
          "Haal 3 naar beneden → 3 ÷ 4 = 0 (schrijf op!)",
          "Haal 6 erbij → 36 ÷ 4 = 9",
          "Antwoord: 309"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.zero-omission", "label": "Vergeet de nul in het quotiënt op te schrijven (ook bij viercijferige delingen)" }
        ]
      }
    },
    {
      "id": "REK-CIJF-DEEL-008",
      "familyId": "REK-CIJF-DEEL",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "cijferend",
      "subSkill": "cijferend_delen",
      "questionType": "cijferend_delen",
      "question": "Reken uit: 1.452 ÷ 6",
      "options": [],
      "correctAnswer": "242",
      "data": {
        "acceptedAnswers": ["242"],
        "operand1": 1452,
        "operand2": 6,
        "longDivision": {
          "dividend": 1452,
          "divisor": 6
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Viercijferig delen",
            "content": "1.452 ÷ 6: 1 ÷ 6 kan niet, neem 14. 14 ÷ 6 = 2 (rest 2). Haal 5 erbij → 25. 25 ÷ 6 = 4 (rest 1). Haal 2 erbij → 12. 12 ÷ 6 = 2. Antwoord: 242.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_deel_4cijferig",
      "variantIndex": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "1.452 ÷ 6 = 242. Staartdeling: 14 ÷ 6 = 2 (rest 2). Haal 5 erbij → 25. 25 ÷ 6 = 4 (rest 1). Haal 2 erbij → 12. 12 ÷ 6 = 2. Antwoord: 242.",
        "solutionSteps": [
          "14 ÷ 6 = 2, rest 2",
          "Haal 5 erbij → 25 ÷ 6 = 4, rest 1",
          "Haal 2 erbij → 12 ÷ 6 = 2",
          "Antwoord: 242"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Negeert de rest bij het naar beneden halen (4-cijferig)" }
        ]
      }
    }
  ]
}